






































import { Component } from "vue-property-decorator";
import Dialog from "@/components/Dialog.vue";
import HacoCommon from "../HacoCommon";
import axios from "axios";

interface LoginForm {
  email: string;
  password: string;
}
@Component({
  components: {
    Dialog
  }
})
/** 認証 */
export default class LoginComp extends HacoCommon {
  loginData: LoginForm = {
    email: "",
    password: ""
  };
  emailPass!: LoginForm;
  $debugServer!: string;
  loaded = false;
  stored = false;
  clicked = false;
  mounted(): void {
    const hacoStorage: Storage = window.localStorage;
    if (hacoStorage.getItem("savedPass")) {
      const passStr: string = hacoStorage.getItem("savedPass") as string;
      this.loginData = JSON.parse(passStr);
      this.stored = true;
    } else {
      this.loginData = {
        email: "",
        password: ""
      };
    }

    const emailEle: HTMLInputElement = document.getElementById(
      "email"
    ) as HTMLInputElement;
    if (emailEle) {
      emailEle.focus();
    }
    /** チラ見対策 */
    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  onSubmit(): void {
    this.clicked = true;
    const url: string = this.$debugServer + "/api/auth/login";
    const params: object = {
      method: "post",
      url: url,
      data: {
        email: this.loginData.email,
        password: this.loginData.password
      },
      xsrfHeaderName: "X-CSRF-Token",
      withCredentials: true
    };

    axios(params)
      .then((response: any): void => {
        const hacoStorage: Storage = window.localStorage;
        hacoStorage.setItem("accessToken", response.data.access_token);
        if (this.stored === true) {
          const savedPass: string = JSON.stringify(this.loginData);
          hacoStorage.setItem("savedPass", savedPass);
        }
        window.location.reload();
      })
      .catch((error: any): void => {
        console.log("[Login Error]", error);
        Object.keys(error).forEach((k: string) => {
          console.log(k, error[k]);
        });
        this.putErrorText(this.$t("message.editCommon.error.error") as string);
        this.clicked = false;
      });
  }
}
